import { useQuery } from '@gogame/query';

import { loadFilterDetails } from 'scenes/Trackers/HourlyTracker/sources/Filters';

import { filterDetails } from './queryKeyFactory';

export const useLoadFilterDetails = (params) => {
  return useQuery(filterDetails(params), () => loadFilterDetails(params), {
    staleTime: Infinity,
  });
};
